import React from 'react'
import changeFileExtension from '@/lib/filename-extension-modifier'
import { object, string } from 'prop-types'
import { EventLivePlayer } from '@/component/Primitive/Events'

const EventLivePlayerWidget = (props) => {
  const { pageData } = props
  const { eventUmbrella } = pageData

  const eventName = eventUmbrella?.event?.name
  const eventFullUrlPath =
    'events/' + eventUmbrella?.slug + '/' + eventUmbrella?.event?.slug
  const agendaSnapshot = eventUmbrella?.event?.agendaSnapshot
  const agenda = eventUmbrella?.event?.agenda

  const getImage = (imageList, context, ratio, size) =>
    imageList?.[`${context}_${ratio}_${size}`]?.[0]

  const createSrcSet = (imageList) => {
    const largeSrcSet = [
      {
        width: 668,
        src: changeFileExtension(
          getImage(imageList, 'cover', '21x9', 668)?.url,
          'webp'
        )
      },
      {
        width: 1336,
        src: changeFileExtension(
          getImage(imageList, 'cover', '21x9', 1336)?.url,
          'webp'
        )
      }
    ]
    const smallSrcSet = [
      {
        width: 320,
        src: changeFileExtension(
          getImage(imageList, 'cover', '1x1', 668)?.url,
          'webp'
        )
      },
      {
        width: 668,
        src: changeFileExtension(
          getImage(imageList, 'cover', '1x1', 320)?.url,
          'webp'
        )
      }
    ]

    return {
      desktop: {
        srcSet: largeSrcSet,
        alt: 'Event Live Video Image',
        sizes: ['min-width(960px) 50vw', '100vw'],
        src: getImage(imageList, 'cover', '21x9', 1336)?.url
      },
      mobile: {
        srcSet: smallSrcSet,
        alt: 'Event Live Video Image',
        sizes: ['min-width(960px) 50vw', '100vw'],
        src: getImage(imageList, 'cover', '1x1', 668)?.url
      }
    }
  }

  const createAgendaItemSrcSet = (agendaItem) => {
    return createSrcSet(agendaItem.images)
  }

  const currentAgendaWithImages = agendaSnapshot.currentAgenda.map(
    (agendaItem) => {
      return {
        ...agendaItem,
        image: createAgendaItemSrcSet(agendaItem)
      }
    }
  )

  const nextAgendaWithImages = agendaSnapshot.nextAgenda.map((agendaItem) => {
    return {
      ...agendaItem,
      image: createAgendaItemSrcSet(agendaItem)
    }
  })

  const fullAgendaWithImages = agenda.map((agendaItem) => {
    return {
      ...agendaItem,
      image: createAgendaItemSrcSet(agendaItem)
    }
  })

  const embellishedAgendaSnapshot = {
    ...agendaSnapshot,
    currentAgenda: currentAgendaWithImages,
    nextAgenda: nextAgendaWithImages,
    holdingImage: createSrcSet(eventUmbrella?.event?.images)
  }

  let displayImage
  if (currentAgendaWithImages.length)
    displayImage = currentAgendaWithImages[0].image
  else if (nextAgendaWithImages.length)
    displayImage = nextAgendaWithImages[0].image
  else displayImage = { desktop: { src: null }, mobile: { src: null } }

  const componentProps = {
    name: 'Current Agenda Item Name Long lond lonkdn ijwbd ionwd ',
    description: 'Current Agenda Item Description',
    locations: eventUmbrella.event.locations,
    eventName,
    eventFullUrlPath,
    image: displayImage,
    live: true,
    agendaSnapshot: embellishedAgendaSnapshot,
    fullAgenda: fullAgendaWithImages
  }
  return <EventLivePlayer {...componentProps} />
}

EventLivePlayerWidget.propTypes = {
  pageData: object,
  descriptionDetails: string
}

export default EventLivePlayerWidget
